import { Befehl27 } from '../../../models'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import {
  convertBefehl27FormDataToModel,
  convertModelToBefehl27FormData
} from './converters'
import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl27FormData, createBefehl27FormValidationSchema } from './schema'
import { useBefehlForm } from '../../../hooks'
import Auftrag27_10Form from './Befehl27_10Form'

/**
 * Main form component for Befehl 27
 */

export default function Befehl27Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-27-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl27>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl27FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl27FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl27FormData(befehl) : undefined
  })
  const handleSubmit = useCallback(
    (data: Befehl27FormData) => {
      const updatedBefehl = convertBefehl27FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )
  return (
    <BefehlFormWrapper<Befehl27FormData>
      befehlKennung="27"
      title={t('befehle.27.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 27.10 */}
      <Auftrag27_10Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-27-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      ></Auftrag27_10Form>
    </BefehlFormWrapper>
  )
}
